<template>
  <div class="container-fluid px-4 mt-4">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>
    <h4 class="mb-4 font-weight-bold text-dark text-center"> {{ this.$route.params.name }} </h4>

    <div class="d-flex justify-content-center mb-4">
      <div class="tab-buttons">
        <b-button
            :variant="activeTab === 0 ? 'warning' : 'outline-warning'"
            class="tab-button"
            @click="changeTab(0)"
        >
          İşlem Geçmişi
        </b-button>

        <b-button
            :variant="activeTab === 1 ? 'success' : 'outline-success'"
            class="tab-button"
            @click="changeTab(1)"
        >
          Dekont Geçmişi
        </b-button>
      </div>
    </div>

    <div class="row" v-show="!loading">
      <!-- ÜRÜN LİSTESİ -->
      <!-- ... -->
      <div class="container">
        <!-- İşlem Geçmişi -->
        <vue-good-table
            v-if="activeTab === 0"
            key="transactions"
            mode="remote"
            @on-page-change="onPageChangeTransactions"
            @on-per-page-change="onPerPageChangeTransactions"
            :rows="rowsTransactions"
            :columns="columnsTransactions"
            :totalRows="totalRecordsTransactions"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: serverParamsTransaction.perPage,
              perPageDropdown: [5, 10, 20],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü'
            }"
        >
          <template slot="table-actions">
            <b-button variant="success" @click="showReportModal = true">
              Rapor İndir
            </b-button>
          </template>
        </vue-good-table>

        <!-- Dekont Geçmişi -->
        <vue-good-table
            v-else
            key="receipts"
            mode="remote"
            @on-page-change="onPageChangeReceipts"
            @on-per-page-change="onPerPageChangeReceipts"
            :rows="rowsReceipts"
            :columns="columnsReceipts"
            :totalRows="totalRecordsReceipts"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: serverParamsReceipts.perPage,
              perPageDropdown: [5, 10, 20, 50],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü'
        }"
            />
      </div>
      <!-- ... -->
    </div>
    <b-modal
        id="reportModal"
        v-model="showReportModal"
        hide-footer
    >
      <b-form @submit.prevent="downloadReport">
        <b-form-group label="Başlangıç Tarihi" label-for="start-date">
          <b-form-datepicker
              id="start-date"
              v-model="reportForm.from"
              required
              placeholder="Başlangıç Tarihi seçiniz"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group label="Bitiş Tarihi" label-for="end-date">
          <b-form-datepicker
              id="end-date"
              v-model="reportForm.to"
              required
              placeholder="Bitiş Tarihi seçiniz"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
              v-model="reportForm.showDescriptions"
          >
            Fatura isimlerini göster
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
              v-model="reportForm.showDetails"
          >
            Faturalardaki hizmet/ürün kalemlerini göster
          </b-form-checkbox>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button variant="secondary" @click="showReportModal = false">
            İptal
          </b-button>
          <b-button
              variant="primary"
              type="button"
              class="ml-2"
              :disabled="!reportForm.from || !reportForm.to"
              @click="downloadMonthlyReport"
          >
            Aylık Rapor İndir
          </b-button>
          <b-button variant="primary" type="submit" class="ml-2" :disabled="!reportForm.from || !reportForm.to">
            İndir
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import ClientService from '../../service/ClientService';
import PaymentService from "@/service/PaymentService";
import * as XLSX from 'xlsx';

export default {
  name: 'admin-transaction-history-list',
  data() {
    return {
      loading: false,
      activeTab: 0,
      totalRecordsTransactions: 0,
      totalRecordsReceipts: 0,
      rowsTransactions: [],
      rowsReceipts: [],
      columnsTransactions: [
        {field: 'id', hidden: true},
        {label: 'İşlem Türü', field: 'transactionType', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Açıklama', field: 'description', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'İşlem Tarihi', field: 'date', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Borç', field: 'debt', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Alacak', field: 'credit', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Bakiye', field: 'balance', tdClass: 'text-center', thClass: 'text-center', sortable: false},
      ],
      columnsReceipts: [
        { label: 'Sipariş Zamanı', field: 'date', sortable: false },
        { label: 'İsim Soyisim', field: 'cardName', sortable: false },
        { label: 'Kart Numarası', field: 'cardNumber', sortable: false, hidden: true },
        { label: 'Sipariş Tutarı', field: 'amount', sortable: false },
      ],
      serverParamsTransaction: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      serverParamsReceipts: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      showReportModal: false,
      reportForm: {
        from: null,
        to: null,
        showDescriptions: false,
        showDetails: false,
      },
      clients: [],
      clientId: this.$route.params.id,
      name: this.$route.params.name,
    };
  },
  methods: {
    // --- İşlem tablosu handlers ---
    onPageChangeTransactions(params) {
      this.serverParamsTransaction = { ...this.serverParamsTransaction, page: params.currentPage };
      this.loadTransactionItems(this.serverParamsTransaction);
    },
    onPerPageChangeTransactions(params) {
      this.serverParamsTransaction = { ...this.serverParamsTransaction, perPage: params.currentPerPage, page: 1 };
      this.loadTransactionItems(this.serverParamsTransaction);
    },

    // --- Dekont tablosu handlers ---
    onPageChangeReceipts(params) {
      this.serverParamsReceipts = { ...this.serverParamsReceipts, page: params.currentPage };
      this.loadReceiptItems(this.serverParamsReceipts);
    },
    onPerPageChangeReceipts(params) {
      this.serverParamsReceipts = { ...this.serverParamsReceipts, perPage: params.currentPerPage, page: 1 };
      this.loadReceiptItems(this.serverParamsReceipts);
    },

    async loadTransactionItems(params) {
      if (!this.clientId) {
        return;
      }
      this.loading = true;
      try {
        const response = await ClientService.getTransactionHistory(this.clientId, params.perPage, params.page);
        this.rowsTransactions = response.data;
        this.totalRecordsTransactions = response.totalCount;
      } catch (error) {
        console.error("Listeleme sırasında hata:", error);
      } finally {
        this.loading = false;
      }
    },
    async loadReceiptItems() {
      this.loading = true;
      try {
        this.serverParamsReceipts.clientId = this.clientId;
        const response = await PaymentService.getReceiptList(this.serverParamsReceipts);
        this.rowsReceipts = response.data;
        this.totalRecordsReceipts = response.total;
      } catch (error) {
        console.error("Dekont geçmişi görüntülenirken hata oluştu:", error);
        this.$errorNotification(this, "Dekont geçmişi görüntülenirken hata oluştu.");
      } finally {
        this.loading = false;
      }
    },
    async downloadReport() {
      this.loading = true;
      try {
        const payload = {
          clientId: this.clientId,
          from: this.reportForm.from,
          to: this.reportForm.to,
          show_descriptions: this.reportForm.showDescriptions,
          show_details: this.reportForm.showDetails
        };
        const downloadUrl = await ClientService.getTransactionHistoryReport(payload);

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank';
        link.setAttribute('download', 'IslemGecmisi.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('PDF indirme hatası:', error);
        this.$errorNotification(this, "Pdf indirilirken hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
      } finally {
        this.showReportModal = false;
        this.loading = false;
      }
    },

    async downloadMonthlyReport() {
      const payload = {
        clientId: this.clientId,
        from: this.reportForm.from,
        to: this.reportForm.to,
      };
      this.loading = true;
      const response = await ClientService.getTransactionHistoryMonthlyReport(payload);

      const rows = response.data.map(item => ({
        'Dönem': item.period,
        'Borç': item.debt,
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Aylık Rapor');

      worksheet['!cols'] = [
        { wch: 25 }, // Dönem
        { wch: 18 }, // Borç
      ];

      const fileName = `aylik-rapor.xlsx`;

      XLSX.writeFile(workbook, fileName);
      this.loading = false;
    },

    changeTab(index) {
      if (this.activeTab !== index) {
        this.activeTab = index;
        if (index === 0) {
          this.loadTransactionItems(this.serverParamsTransaction);
        } else if (index === 1) {
          this.loadReceiptItems(this.serverParamsReceipts);
        }
      }
    },
  },
  beforeMount() {
    this.loadTransactionItems(this.serverParamsTransaction);
  }
};
</script>

<style scoped>

</style>
